<template>
    <div>
        <div class="alert alert-danger" v-if="isCompanion">
            {{ $i18n.auth.session_expired_companion }}
        </div>
        <div class="login-page" v-else>
            <div class="row">
                <div class="col-md-6 col-md-offset-3 text-center logo-login">
                    <div id="logo-image"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-5 col-sm-12 col-xs-12 well">
                    <login-form :login-action="loginAction" :user="user"></login-form>
                </div>
            </div>

            <!-- Hide until implemented -->
            <div class="row" v-if="false">
                <div class="col-md-6 col-md-offset-3 text-center">

                    <h4>{{ $i18n.auth.already_connected }}</h4>

                    <div class="form-group">
                        <social-login fa-icon="fab fa-facebook-f" text="Login with Facebook" :login-action="loginWithFacebook"></social-login>
                    </div>

                    <div class="form-group">
                        <social-login fa-icon="fa fa-lock" text="Login with Multibrain" :login-action="loginWithMultibrain"></social-login>
                    </div>
                </div>
            </div>
        </div>
        <language-selector></language-selector>
    </div>
</template>

<script type="text/javascript">
    import SocialLogin from './login/social-login.vue';
    import LoginForm from './login/login-form.vue';
    import LanguageSelector from './language-selector.vue';

    export default {
        name: 'login',

        props: ['logo'],

        data: function() {
            return {
                user: {
                    email: '',
                    password: '',
                    remember: false
                },
                error: false,
                isCompanion: false
            }
        },
        methods: {
            loginAction: function(){

                var success = (response) => {
                    if(response !== undefined && response.data !== undefined){
                        eventHub.$emit('user.login', response.data.data, this.user.remember);

                        localStorage.setItem('token', response.data.data.token);

                        var redirect = Cookies.get('login-redirect');
                        if (redirect !== undefined) {
                            Cookies.expire('login-redirect');
                            window.location = '/app' + redirect;
                            return;
                        }

                        window.location = '/app/dashboard';
                    }
                };

                var failure = (response) => {
                    var msg = response.data.message;
                    var errors = response.data.errors;

                    for (var key in errors) {
                        if (errors.hasOwnProperty(key)) {
                            msg += '\n' + errors[key];
                        }
                    }

                    swal({
                        title: this.$i18n.general.oops,
                        text: msg,
                        icon: 'error',
                        buttons: [this.$i18n.auth.login_in_failure.try_again, this.$i18n.auth.login_in_failure.reset_password]
                    }).then((confirmed) => {
                        if (confirmed) {
                            this.$router.push('recover-password');
                        }
                    });
                };

                this.$http.post('session', this.user).then(success, failure);
            },

            loginWithFacebook: function () {
                console.log('login with Facebook');
            },

            loginWithTwitter: function () {
                console.log('login with Twitter');
            },

            loginWithMultibrain: function () {
                console.log('login with Multibrain');
            }
        },

        components: { SocialLogin, LoginForm, LanguageSelector},

        mounted: function() {
            this.isCompanion = /Multibrain\/Companion/.test(window.navigator.userAgent);

            var self = this;
            this.$nextTick(function () {
                if (window.error !== undefined) {
                    swal({
                        title: self.$i18n.general.oops,
                        text: window.error.message,
                        icon: 'error',
                        button: self.$i18n.general.ok
                    });
                    delete window.error;
                }
            });

            this.$nextTick(function () {
                this.$http.get('session', this.user).then(function(response) {
                    if(response !== undefined && response.data !== undefined){
                        if (response.data.data.token !== undefined) {
                            eventHub.$emit('user.login', response.data.data, this.user.remember);

                            localStorage.setItem('token', response.data.data.token);

                            var redirect = Cookies.get('login-redirect');
                            if (redirect !== undefined) {
                                Cookies.expire('login-redirect');
                                window.location = '/app' + redirect;
                                return;
                            }

                            window.location = '/app/dashboard';
                        }
                    }
                }).catch(error => {
                    // user is unauthenticated
                    if(Cookies.get('login-redirect')) {
                        // user attempted to access a specific page before logging in

                        // admins can get stuck in a loop of redirects
                        // we'll keep track of the number of times they've been here
                        // and nope out if they appear to be stuck
                        var redirectCount = parseInt(Cookies.get('login-redirect-count')) || 0;
                        Cookies.set('login-redirect-count', (redirectCount + 1), { expires: 60 });

                        if(redirectCount >= 2) {
                            Cookies.expire('login-redirect');
                            Cookies.expire('login-redirect-count');
                            return;
                        }

                        // special handling only for R+F for now
                        switch (window.location.hostname) {
                            case 'rodan.test':
                            case 'stg-social.rodanandfields.com':
                            case 'social.rodanandfields.com':
                                window.location.replace('/');
                                return;
                        }
                    }
                });
            })
        }

    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/login.vue